import React from 'react';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Stack,
} from '@mui/material';
import { AppColors } from '../../../Utils/helper/AppColors';
import CustomTag from '../../../Components/CustomTag';

export function InsightsTable({ data = [], issues = false , sx }) { 
  console.log('Table Data:', data);
  return (
    <TableContainer sx={{ height: 'calc(100vh - 200px)', backgroundColor: AppColors.WHITE, ...sx }}>
      <Table stickyHeader>
        <TableHead
          sx={{
            '& .MuiTableCell-root': {
              fontSize: 14,
              lineHeight: '150%',
              letterSpacing: '0%',
              fontFamily: 'Poppins',
              color: AppColors.HEADING_TITLE2,
              fontWeight: 600,
              height: 60,
            },
          }}
        >
          <TableRow
            sx={{
              '& .MuiTableCell-root': {
                paddingTop: '10px',
                paddingBottom: '10px',
                minHeight: 61,
              },
            }}
          >
           { issues ? 
             ( 
              <>
              <TableCell width="30%">Issues</TableCell>
              {/* <TableCell width="10%">Count</TableCell> */}
              </>
            ) : (
              <>
              <TableCell width="30%">Insight</TableCell>
              {/* <TableCell width="10%">Count</TableCell> */}
              <TableCell width="60%">Mentions</TableCell>
            </>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((insight, index) => (
            <TableRow key={index}>
              <TableCell sx={theme => ({color : theme.palette.primary.darker_primary , fontFamily: 'Poppins'})}>{issues ? insight.issue : insight.insight}</TableCell>
              {/* <TableCell sx={{fontWeight: 600 , fontSize: 14 , fontFamily: 'Poppins'}}>{insight.count}</TableCell> */}

            { !issues && <TableCell >
                 <Stack direction="row" gap={2}>
                {insight.mentions.map((mention, idx) => (
                  // <Typography key={idx} variant="body2">{mention}</Typography>
                  <CustomTag  tagTitle={mention} maxWidth={'800px'} fontSize={14} fontWeight={500} lineHeight={'150%'} /> 
                ))}</Stack>
              </TableCell> }
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}